import { Component, Input, Output, EventEmitter } from '@angular/core';
import { BvButtonVariant, BvButtonComponent } from '../../design-system/primitives/button.component';

@Component({
    selector: 'app-file-input',
    templateUrl: './file-input.component.html',
    styleUrls: ['./file-input.component.scss'],
    imports: [BvButtonComponent]
})
export class FileInputComponent {
  @Input() accept: string = '*';
  @Input() capture!: string;
  @Input() disabled: boolean = false;
  @Input() variant: BvButtonVariant = 'secondary';
  /** Allow picking several files; each is emitted on `select`, all on `selectMany`. */
  @Input() multiple: boolean = false;
  @Output() select = new EventEmitter<File>();
  @Output() selectMany = new EventEmitter<File[]>();

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const files = Array.from(input.files);
      this.selectMany.emit(files);
      if (!this.multiple) this.select.emit(files[0]);
      else files.forEach((f) => this.select.emit(f));
      // Reset so the same file can be picked again after a removal.
      input.value = '';
    }
  }

  triggerFileInput(): void {
    const fileInput = document.getElementById('file-input-' + Math.random().toString(36).substr(2, 9));
    if (fileInput) {
      fileInput.click();
    }
  }
}